import React, { useState, useEffect } from "react";
import axios from "axios";
import ContactService from "../../services/contact-service";

const AdresseForm = ({ setCodePostal, handleReinitial, value }) => {
  const [ville, setVille] = useState(value || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Mettre à jour `ville` lorsque la prop `value` change, sans modifier `ville` manuellement.
  useEffect(() => {
    if (value !== ville) {
      setVille(value);
    }
  }, [value]);

  // Fonction pour gérer le changement de ville
  const handleVilleChange = (e) => {
    const newVille = e.target.value;
    setVille(newVille);

    // Ne pas effectuer de requête API si le champ est vide ou si la ville est trop courte
    if (newVille.trim().length < 3) {
      return;
    }

    setLoading(true);
    setError(null);

    // Requête API à Nominatim
    axios
      .get(`https://nominatim.openstreetmap.org/search?q=${newVille}&format=json&addressdetails=1&limit=1`)
      .then((response) => {
        const data = response.data;
        if (data && data.length > 0 && data[0].address) {
          const codePostal = data[0].address.postcode || "Code postal non disponible";
          
          // Met à jour le code postal dans le composant parent
          setCodePostal(codePostal, newVille);

          // Appelle le service pour obtenir le secteur lié
          ContactService.searchSecteur(codePostal).then((res) => {
            console.log("Secteur trouvé :", res);
          });
        } else {
          // Si aucun code postal trouvé, garder la valeur de ville saisie sans réinitialisation
          console.warn("Aucun code postal trouvé pour la ville:", newVille);
          setCodePostal("", newVille);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la requête API :", error);
        setError("Erreur de chargement");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <label htmlFor="ville">Ville</label>
      <input
        className="form-control"
        type="text"
        placeholder="Saisir la ville"
        value={ville}
        onChange={handleVilleChange}
      />
      {loading && <p>Chargement...</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default AdresseForm;
